export default __webpack_public_path__ + "static/loading-5f4c09c5a2dd6cc701ccb8158b67fa2b.gif";